import { PersonCards } from "../../global/person-card";
import { Carousel } from "react-responsive-carousel";

//assets
import Doc1 from "../../../assets/images/doc1.png";
import Doc2 from "../../../assets/images/doc2.png";
import Doc3 from "../../../assets/images/doc3.png";
import { Title } from "../../global/title/title";

export const Doctors = () => {
  return (
    <div className="doctors">
      <div className="container section ">
        <Title black="Recommended" blue="Doctors" />
        <div className="mt--large"></div>
        <Carousel infiniteLoop useKeyboardArrows autoPlay>
          <PersonCards list={list} />
          <PersonCards list={list2} />
        </Carousel>
      </div>
    </div>
  );
};

const list = [
  {
    id: "1",
    img: Doc1,
    name: "Esther Howard",
    desc: "Specialization",
  },
  {
    id: "2",
    img: Doc2,
    name: "Jenny Wilson",
    desc: "Specialization",
  },
  {
    id: "3",
    img: Doc3,
    name: "Wade Warren",
    desc: "Specialization",
  },
];
const list2 = [
  {
    id: "1",
    img: Doc2,
    name: "Esther Howard",
    desc: "Specialization",
  },
  {
    id: "2",
    img: Doc3,
    name: "Jenny Wilson",
    desc: "Specialization",
  },
  {
    id: "3",
    img: Doc1,
    name: "Wade Warren",
    desc: "Specialization",
  },
];
